module.exports = __webpack_public_path__ + "static/media/register.9d149f79.jpg";